import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Card } from '../../../../components/Card';
import { List, Row, Cell } from '../../../../components/List';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { setNewInvoiceValue } from '../../actions';
import { VehicleInvoiceField } from './FieldsVehicle';
import { KanbanProgressBar } from '../../../KanbanBoards/components/ProgressBar';
import { getDate } from '../../../Vehicles/helpers';
import { VehicleStatusCard } from '../../../Vehicles/components/CardStatus';
import { selectUserId, selectWork } from '../../../Api/selectors';
import { getPropByName, getPropertyValueObjectByName } from '../../../../utils/props';
import { REQUEST_USER } from '../../../Users/constants';
import { fetchUser } from '../../../Users/actions';
import { Loader } from '../../../../components/Loader';
import { selectConfig } from '../../../Api/selectors';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { RegplateLabel } from '../../../Vehicles/components/RegplateLabel';
import { selectVehicle, selectVehicleProperty } from '../../../Vehicles/selectors';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { WithVehicleProperty } from '../../../Vehicles/components/WithVehicleProperty';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY } from '../../../Vehicles/constants';

const Container = styled.div`
  .secondary-info {
    white-space: nowrap;
    padding: 0 4px;
    font-weight: 600;
    color: #6e6e6e;
    border-right: ${props => (props.width <= 768 ? 'none' : '1.5px solid #6e6e6e')};
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class VehicleInvoiceCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.productOverview && this.props.vehicle?.user_changed_status) {
      this.props.fetchUser(this.props.vehicle?.user_changed_status, result => this.setState({ user: result }));
    }
  }

  getFieldValue(fieldName) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    return this.props.vehicle[fieldName];
  }

  get statusUpdatedAt() {
    const date = getPropertyValueObjectByName(this.props.vehicle, 'status')?.updatedAt;
    const parsedDate = getDate(date, true);
    return parsedDate;
  }

  get userChangedStatus() {
    let name = this.state.user ? getPropByName(this.state.user, 'name') : this.props.changedStatusUser?.name || '';

    let surname = this.state.user ? getPropByName(this.state.user, 'surname') : this.props.changedStatusUser?.surname || '';
    return `${name} ${surname}`;
  }

  get statusRemark() {
    if (!this.props.vehicle?.status_remark) return '';

    return `${this.props.vehicle?.status_remark}`;
  }

  renderSecondaryInfo(vehicle) {
    return window.innerWidth <= 768 ? (
      <VBox>
        <span className="secondary-info">
          {' '}
          <RegplateLabel regplate={vehicle.regplate} />
        </span>
        <span className="secondary-info">{vehicle?.mileage}</span>
        <span className="secondary-info">{getDate(vehicle?.date_first_allowance)}</span>
        <KanbanProgressBar type="vehicle" target={vehicle} height={7} width={120} />
      </VBox>
    ) : (
      <>
        <HBox left>
          <span className="secondary-info">{vehicle?.mileage}</span>
          <span className="secondary-info">{getDate(vehicle?.date_first_allowance)}</span>{' '}
        </HBox>
        <VBox left>
          <RegplateLabel regplate={vehicle.regplate} />
        </VBox>
      </>
    );
  }

  fieldDisabledForInstallation(name) {
    switch (name) {
      case 'import':
        return this.props.serverConfig.disabledImport;
      default:
        return false;
    }
  }

  get types() {
    let types = this.props.types ?? [];

    return types.filter(t => !this.fieldDisabledForInstallation(t));
  }

  render() {
    const vehicle = this.props.vehicle;

    const HOOI_inslag_done_date = vehicle?.HOOI_inslag_done_date
      ? new Date(vehicle.HOOI_inslag_done_date)
      : new Date().toISOString();
    const HOOI_uitslag_done_date = vehicle.HOOI_uitslag_done_date
      ? new Date(vehicle.HOOI_uitslag_done_date)
      : new Date().toISOString();
    const days = Math.floor((new Date(HOOI_uitslag_done_date) - new Date(HOOI_inslag_done_date) + 86400000) / 86400000);
    const brandName = this.props.productOverview ? 'brand_name' : 'brandName';
    const modelName = this.props.productOverview ? 'model_name' : 'modelName';
    const description = this.props.productOverview ? 'model_info' : 'description';


    return (
      <Card className="vehicle-info-card info-card info">
        <Container width={window.innerWidth}>
          <HBox vCenter left>
            <WithVehicle vehicle_id={vehicle.id}>
              <VehicleAvatar vehicle={this.props.fetchedVehicle} />
            </WithVehicle>
            <VBox style={{ cursor: 'pointer' }} onClick={this.tofn(`/vehicles/${vehicle?.id}`)}>
              {window.innerWidth > 768 && (
                <>
                  {' '}
                  <h3>
                    {vehicle[brandName] ?? ''} {vehicle[modelName] ?? ''}
                  </h3>
                  <div>{vehicle[description] ?? ''}</div>
                </>
              )}
              <div className="type">{vehicle?.type}</div>

              {this.props.productOverview && this.renderSecondaryInfo(vehicle)}
            </VBox>
          </HBox>

          <WithVehicleProperty vehicleId={this.props.vehicle?.id} propertyName={'status'} loader={this.props.workProperty}>
            <VehicleStatusCard
              readOnly
              loggedInUserId={this.props.loggedInUserId}
              vehicle={this.props.fetchedVehicle}
              status={this.props.status}
            />
          </WithVehicleProperty>
          <List>
            {this.props.productOverview && (
              <>
                <Row key={'status_log'}>
                  <div style={{ margin: '5px' }}>
                    {this.statusUpdatedAt || ''}
                    &nbsp;
                    {vehicle?.user_changed_status && (
                      <p style={{ margin: '0px' }}>
                        {this.lbl('vehicle.details.status_log.filled_by')} &nbsp;
                        {this.props.work ? <Loader small /> : this.userChangedStatus}
                      </p>
                    )}
                    {this.statusRemark?.trim()?.length >= 1 && (
                      <p style={{ margin: '0px' }}>
                        {this.lbl('vehicle.details.status_log.remark')}: &nbsp;
                        {this.statusRemark}
                      </p>
                    )}
                  </div>
                </Row>
                <Row key={'stage_days'}>
                  <Cell>{this.lbl(`vehicle.property.days_is_stock`)}</Cell>
                  {env.clientId !== AppClientId.HOOIKAMMER ? (
                    <></>
                  ) : (
                    <Cell>{vehicle.HOOI_inslag_done_date ? days : 'Geen inslag'}</Cell>
                  )}
                </Row>
                {vehicle['date_expected'] && (
                  <Row key={'add_to_order'}>
                    <Cell>{this.lbl(`vehicle.property.date_expected`)}</Cell>
                    <Cell>{getDate(vehicle['date_expected'])}</Cell>
                  </Row>
                )}
              </>
            )}
            {this.types?.map(type => (
              <VehicleInvoiceField
                isRequire={this.props.isRequire}
                vehicle={vehicle}
                type={type}
                key={type}
                calculateFinAmounts={this.props.calculateFinAmounts}
              />
            ))}
          </List>
        </Container>
      </Card>
    );
  }
}

VehicleInvoiceCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedInUserId: selectUserId(),
    work: selectWork(REQUEST_USER, REQUEST_VEHICLE),
    fetchedVehicle: selectVehicle(ownProps.vehicle.id),
    workProperty: selectWork(REQUEST_VEHICLE_PROPERTY + '-' + 'status' + '-' + ownProps.vehicle.id),
    serverConfig: selectConfig(),
    status: selectVehicleProperty(ownProps.vehicle?.id, 'status'),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      dispatch(setNewInvoiceValue(name, value));
    },
    fetchUser(id, callback) {
      dispatch(fetchUser(id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleInvoiceCard = compose(withConnect, withRouter)(VehicleInvoiceCardComp);
